import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match?.[1];
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        await axios.post(
          `${API}/auth/session`,
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        await refresh();
      } catch (e) {
        console.error("Auth callback failed", e);
      } finally {
        // Honour a post-auth redirect intent set by the Discovery flow (or any
        // other page that captures state before the OAuth round-trip). Falls
        // back to /projects, the original destination, otherwise.
        let dest = "/projects";
        try {
          const stored = sessionStorage.getItem("bnm.postAuthRedirect");
          if (stored && stored.startsWith("/")) {
            dest = stored;
            sessionStorage.removeItem("bnm.postAuthRedirect");
          }
        } catch {
          // ignore private-mode / quota errors
        }
        window.history.replaceState({}, "", dest);
        navigate(dest, { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="cine-bars" aria-hidden>
        <span className="cine-bar" />
        <span className="cine-bar" />
        <span className="cine-bar" />
        <span className="cine-bar" />
        <span className="cine-bar" />
      </div>
    </div>
  );
}
